import { render, staticRenderFns } from "./smallBag.vue?vue&type=template&id=9013a3b8&scoped=true"
import script from "./smallBag.vue?vue&type=script&lang=js"
export * from "./smallBag.vue?vue&type=script&lang=js"
import style0 from "./smallBag.vue?vue&type=style&index=0&id=9013a3b8&prod&lang=scss"
import style1 from "./smallBag.vue?vue&type=style&index=1&id=9013a3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9013a3b8",
  null
  
)

export default component.exports